import { Container as EbdsContainer } from '@boschebike/ebds-react';
import React from 'react';
import { PlatformContext } from '../../context/platformContext';

interface ContainerProps {
  customContainerClassName?: string;
  multiColumn?: boolean;
}

/**
 * "dxf-container-fix" class is used here as a hack to fix the First Spirit styling mismatch and
 * to be more concise with First Spirit's styling. Should be removed in future
 */
export const Container: React.FunctionComponent<React.PropsWithChildren<ContainerProps>> = ({ children, customContainerClassName = '', multiColumn = false }) => {
  const platformContext = React.useContext(PlatformContext);
  const containerDXF = platformContext.isDXF ? 'dxf-container-fix' : '';

  return (
    <EbdsContainer multiColumn={multiColumn} customContainerClassName={customContainerClassName}>
      <div className={containerDXF}>{children}</div>
    </EbdsContainer>
  );
};
